class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("faq-section", FaqSection);

class FaqBox extends HTMLElement {
  static observedAttributes = ["collapsed"];
  constructor() {
    super();

    this.question = this.querySelector(".faq-box__question");
    this.answer = this.querySelector(".faq-box__answer");
    this.question.addEventListener("click", this.handleCollapse.bind(this));
  }
  handleCollapse() {
    this.collapsed == "true"
      ? this.setAttribute("collapsed", "false")
      : this.setAttribute("collapsed", "true");
  }
  attributeChangedCallback(name, newValue) {
    switch (name) {
      case "collapsed":
        this.collapsed = newValue;
    }
  }
}

customElements.define("faq-box", FaqBox);
